import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import AppContext from "../../container/context";
import { Card, CardContent, CircularProgress, Grid } from "@mui/material";
import { Link } from "react-router-dom";
import mes from "../../enums/mes";
import { mergeParams } from "../../helpers/helpers";

export default function DashboardPagamentos({ history, location }) {
  const { notification } = useContext(AppContext);
  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        ano: new Date().getFullYear(),
      },
      location
    )
  );
  const [carregando, setCarregando] = useState(false);
  const [registros, setregistros] = useState([]);
  const [totais, setTotais] = useState([]);

  useEffect(() => {
    carregarRelatorio();
  }, []);

  const carregarRelatorio = (filtroEnviar = filtros) => {
    setCarregando(true);
    setFiltros(filtroEnviar);

    api
      .get("relatorios/pagamentosAnual", filtroEnviar)
      .then((registros) => {
        let valorTotal = 0;
        let recebido = 0;
        let aReceber = 0;
        let vencido = 0;

        registros.forEach((r) => {
          valorTotal += r.valorTotal;
          recebido += r.valorRecebido;
          aReceber += r.valorAReceber;
          vencido += r.valorVencido;

          r.valorTotal = (r.valorTotal / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });
          r.valorRecebido = (r.valorRecebido / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          });
          r.valorAReceber = r.valorAReceber
            ? (r.valorAReceber / 100).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
            : null;
          r.valorVencido = r.valorVencido
            ? (r.valorVencido / 100).toLocaleString("pt-BR", {
                style: "currency",
                currency: "BRL",
              })
            : null;
        });

        const totais = {
          valorTotal: (valorTotal / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          recebido: (recebido / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          aReceber: (aReceber / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
          vencido: (vencido / 100).toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
          }),
        };

        setregistros(registros);
        setCarregando(false);
        setTotais(totais);
      })
      .catch((e) =>
        notification("error", "Erro ao carregar o relatório: " + e)
      );
  };

  const fFiltros = {
    title: "Período",
    form: {
      ano: {
        label: "Ano",
        type: "number",
        value: filtros.ano,
      },
    },
    submit: {
      label: "carregar",
      action: carregarRelatorio,
    },

    urlParams: true,
    history,
    location,
  };

  const fTotais = {
    title: "Totais",
    form: {
      valorTotal: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Valor total</h4>
            <p>{totais.valorTotal}</p>
          </div>
        ),
      },
      recebido: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>Recebido</h4>
            <p>{totais.recebido}</p>
          </div>
        ),
      },
      aReceber: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>A receber</h4>
            <p>{totais.aReceber}</p>
          </div>
        ),
      },
      vencido: {
        label: "Componente",
        type: "component",
        space: 3,
        value: (
          <div>
            <h4>A receber (vencido)</h4>
            <p>{totais.vencido}</p>
          </div>
        ),
      },
    },

    urlParams: true,
    history: history,
    location: location,
  };

  return (
    <div>
      {carregando ? (
        <CircularProgress />
      ) : (
        <>
          <Form formData={fFiltros} />
          <Form formData={fTotais} />

          <Grid container spacing={2} justifyContent="start">
            {registros.map((item, key) => (
              <Grid item xs={3}>
                <Card sx={{ maxWidth: 300 }}>
                  <CardContent>
                    <h4>{`${mes.desc(item.mes)}/${item.ano}`}</h4>
                    <br />
                    <h4>Total: </h4> <p>{item.valorTotal}</p>
                    <br />
                    <h4>Recebido: </h4> <p>{item.valorRecebido}</p>
                    {item.valorAReceber && (
                      <div>
                        <h4>A receber (no prazo): </h4>{" "}
                        <p>{item.valorAReceber}</p>
                      </div>
                    )}
                    {item.valorVencido && (
                      <div>
                        <h4>A receber (vencido): </h4>{" "}
                        <p>{item.valorVencido}</p>
                      </div>
                    )}
                    <br />
                    <Link
                      to={`/app/relatorio-pagamentos?anoInicio=${item.ano}&mesInicio=${item.mes}&anoFim=${item.ano}&mesFim=${item.mes}`}
                      /*target="_blank"*/
                      style={{
                        color: "black",
                        fontWeight: "bolder",
                        textDecoration: "underline",
                      }}
                    >
                      Relatório completo
                    </Link>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </>
      )}
    </div>
  );
}
